import template1 from './1/component';

const templates = {
	1: template1,
};

export default templates;
export function ModalNewsletter(templateId = 1) {
	return templates[templateId]();
}
